"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function CopiedBox(_a) {
    var { onClose, isOpen } = _a, other = __rest(_a, ["onClose", "isOpen"]);
    const { t } = (0, i18n_1.useTranslation)();
    return (isOpen && ((0, jsx_runtime_1.jsxs)(StyledCopiedBox, Object.assign({}, other, { children: [(0, jsx_runtime_1.jsx)(CopiedText, { children: t(i18n_1.Strings.toolbar.linkCopied) }), (0, jsx_runtime_1.jsx)(DismissButton, { onClick: onClose, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { width: 12, height: 12, name: ui_1.Icons.Cross }) })] }))));
}
exports.default = CopiedBox;
const StyledCopiedBox = styled_components_1.default.div `
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  margin-top: 8px;
  border-radius: 8px;
  white-space: nowrap;
  ${({ theme }) => (0, styled_components_1.css) `
      background-color: ${theme.grasshopper.menuButtons.toastBackground};
    `};
`;
const CopiedText = styled_components_1.default.span `
  font-family: 'Elsevier Sans';
  font-size: 15px;
  white-space: nowrap;
`;
const DismissButton = styled_components_1.default.button `
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
`;
